/**
 * Simple utility function to map empty string search terms to null.
 * This function returns the value (a non-empty string or null), but casts empty strings to null.
 */
export const getCleanSearchTerm = (searchTerm: string | null): string | null => {
  return searchTerm !== '' ? searchTerm : null
}
